import { bool, number, string, oneOf } from 'prop-types';

import { LAYOUTS } from './constants';

export const promoCodeType =  {
    messageId: number,
    userId: number,
    withExpirationDate: bool,
    discountValue: number,
    code: string,
    expirationDate: string,
    termsAndConditionSlug: string
};

export const discountPromoCodeNoticeType = {
    ...promoCodeType,
    layout: oneOf([LAYOUTS.COLUMN, LAYOUTS.ROW])
};
